var _ = require('underscore'),
    FR_ApiModel = require('./frApiModel');


/**
 * Wrapper around frApiModel -- used to break down into searches with and without permission.
 * For now we are leaving permission logic out of the apiModel.
 */


var PredefinedSearchesWrapper = function() {

    this.frApiModel = null;
    this.aValidSearchesWithPermission = [];
    this.aValidSearchesWithoutPermission = [];

};



_.extend( PredefinedSearchesWrapper.prototype, {

    /**
     * userProvidedSearches: those provided to the module.
     * aDisallowedFindAndRedactNoteTypes: those from the creatableNoteTypesHelper.
     * fnGetNewModel: fn passed from the module channel -- hack
     */
    initialize: function( userProvidedSearches, aDisallowedFindAndRedactNoteTypes, fnGetNewModel ) {

        this.frApiModel = new FR_ApiModel( userProvidedSearches );

        if ( this.frApiModel.hasValidSearches() ) {

            var validPredefinedSearches =
                this.frApiModel.getSearchesModelsFromApiModels( fnGetNewModel );

            validPredefinedSearches.forEach( function( search ) {

                if ( aDisallowedFindAndRedactNoteTypes.indexOf( search.getNoteModel().getNoteTypeGroup() ) > -1 ) {

                    this.aValidSearchesWithoutPermission.push( search );

                } else  {

                    this.aValidSearchesWithPermission.push( search );
                }

            }, this);

        }

    },

    getApiModel: function() {

        return this.frApiModel;
    },

    getValidSearchesWithoutPermission: function() {

        return this.aValidSearchesWithoutPermission;

    },

    getValidSearchesWithPermission: function() {

        return this.aValidSearchesWithPermission;

    }



} );



module.exports = PredefinedSearchesWrapper;


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/models/api/PredefinedSearchesWrapper.js
 ** module id = 674
 ** module chunks = 0
 **/